export default __webpack_public_path__ + "static/media/oh-hell-no.fcf1880d.gif";